export function VerifiedFull() {
  return (
    <path
      fill="currentColor"
      d="M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm9.628 16.177L21.013 28.792l-6.64-6.64c-.559-.558-1.463-.558-2.021 0-.558.557-.558 1.462 0 2.02l7.65 7.65c.28.28.645.419 1.01.419.366 0 .732-.14 1.01-.418l13.626-13.626c.558-.557.558-1.462 0-2.02s-1.462-.558-2.02 0z"
    />
  )
}
